import { render, staticRenderFns } from "./MyFilterSelector.vue?vue&type=template&id=b65b2ef2&scoped=true"
import script from "./MyFilterSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyFilterSelector.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MyFilterSelector.vue?vue&type=style&index=0&id=b65b2ef2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65b2ef2",
  null
  
)

export default component.exports